let _connection: any|undefined = undefined

export const setConnection = (connection: any) => {
  _connection = connection;
};
export const getConnection = (): any => {
  return _connection!
}
